module.exports = __webpack_public_path__ + "img/theme-a.660ae620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-a.png
// module id = sWGP
// module chunks = 1